import { useState, useRef, useEffect } from 'react';

const ClickOutside = ({ onClickOutside, children, ...restProps }) => {
  const [isTouch, setIsTouch] = useState(false);
  const container = useRef(null);

  const handle = (event) => {
    if (event.type === 'touchend') {
      setIsTouch(true);
    }

    const isCorrectEvent = !(event.type === 'click' && isTouch);
    const shouldTriggerCallback = container && !container.current.contains(event.target);

    // behavior override for browser
    if (isCorrectEvent && shouldTriggerCallback) {
      onClickOutside(event);
    }
  };

  useEffect(() => {
    document.addEventListener('touchend', handle, true);
    document.addEventListener('click', handle, true);

    return () => {
      document.removeEventListener('touchend', handle, true);
      document.removeEventListener('click', handle, true);
    };
  }, []);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <div {...restProps} ref={container}>{children}</div>;
};

export default ClickOutside;
